// src/components/admin/flows/panels/ConditionConfigForm.js
import React from 'react';
import { useTheme } from '../../../../contexts/ThemeContext';
import { CONDITION_FIELDS, CONDITION_OPERATORS } from '../canvas/nodeRegistry';

const ConditionConfigForm = ({ config, onChange }) => {
    const { theme } = useTheme();
    const isDark = theme === 'dark';

    const inputClass = `w-full px-3 py-2 rounded-lg text-sm border ${
        isDark ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300 text-gray-900'
    } focus:ring-2 focus:ring-blue-500 focus:outline-none`;

    const labelClass = `block text-xs font-medium mb-1 ${isDark ? 'text-gray-400' : 'text-gray-500'}`;

    const selectedField = CONDITION_FIELDS.find(f => f.value === config.field);

    return (
        <div className="space-y-4">
            {/* Field */}
            <div>
                <label className={labelClass}>Field</label>
                <select
                    value={config.field || ''}
                    onChange={(e) => onChange({ ...config, field: e.target.value })}
                    className={inputClass}
                >
                    <option value="">Select field...</option>
                    {CONDITION_FIELDS.map(f => (
                        <option key={f.value} value={f.value}>{f.label}</option>
                    ))}
                </select>
            </div>

            {/* Operator */}
            <div>
                <label className={labelClass}>Operator</label>
                <select
                    value={config.operator || 'equals'}
                    onChange={(e) => onChange({ ...config, operator: e.target.value })}
                    className={inputClass}
                >
                    {CONDITION_OPERATORS.map(op => (
                        <option key={op.value} value={op.value}>{op.label}</option>
                    ))}
                </select>
            </div>

            {/* Value */}
            <div>
                <label className={labelClass}>Value</label>
                {selectedField?.type === 'select' ? (
                    <select
                        value={config.value || ''}
                        onChange={(e) => onChange({ ...config, value: e.target.value })}
                        className={inputClass}
                    >
                        <option value="">Select value...</option>
                        {selectedField.options.map(opt => (
                            <option key={opt} value={opt}>{opt}</option>
                        ))}
                    </select>
                ) : selectedField?.type === 'number' ? (
                    <input
                        type="number"
                        value={config.value || ''}
                        onChange={(e) => onChange({ ...config, value: parseFloat(e.target.value) || '' })}
                        className={inputClass}
                        placeholder="Enter number..."
                    />
                ) : (
                    <input
                        type="text"
                        value={config.value || ''}
                        onChange={(e) => onChange({ ...config, value: e.target.value })}
                        className={inputClass}
                        placeholder="Enter value..."
                    />
                )}
            </div>

            {/* Preview */}
            <div className={`p-3 rounded-lg text-xs ${isDark ? 'bg-gray-700' : 'bg-gray-50'}`}>
                <p className={`font-medium mb-1 ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>Condition Preview</p>
                <p className={isDark ? 'text-gray-400' : 'text-gray-500'}>
                    If <span className="font-semibold">{selectedField?.label || config.field || '...'}</span>{' '}
                    <span className="font-semibold">{CONDITION_OPERATORS.find(o => o.value === config.operator)?.label?.toLowerCase() || '...'}</span>{' '}
                    <span className="font-semibold">"{config.value || '...'}"</span>
                </p>
            </div>
        </div>
    );
};

export default ConditionConfigForm;
